import { render, staticRenderFns } from "./remarkCell.vue?vue&type=template&id=be4882ea&scoped=true"
import script from "./remarkCell.vue?vue&type=script&lang=js"
export * from "./remarkCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4882ea",
  null
  
)

export default component.exports